import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import process from 'process/browser';
import { Buffer } from 'buffer';
import './polyfill'
import './setupMonkeyPatch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import store from './store'

import { App as CapacitorApp } from '@capacitor/app';

import { Toast } from '@capacitor/toast'
import { initializeSessionRefresh, isScannerRunning, stopScanner } from './utils/common';
import { Capacitor } from '@capacitor/core';

React.icons = icons

if (typeof window !== 'undefined') {
  if (!window.process) {
    window.process = process;
  }

  if (!window.process.env) {
    window.process.env = {};
  }

  if (!window.global) {
    window.global = window;
  }

  if (!window.Buffer) {
    window.Buffer = Buffer;
  }
}

window.platform = {
  name: window.Capacitor.getPlatform(),
  isWeb: window.Capacitor.getPlatform() === 'web',
  isMobile: window.Capacitor.getPlatform() === 'android' || window.Capacitor.getPlatform() === 'ios',
  isAndroid: window.Capacitor.getPlatform() === 'android',
  isIos: window.Capacitor.getPlatform() === 'ios',
}

initializeSessionRefresh();

if (document.body) {
  document.body.classList.add(`platform-${window.platform.name}`);

  if (window.platform.isMobile) {
    document.body.classList.add('platform-mobile');
  }
}

const renderReactDom = () => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );
};

function applySafeArea() {
  const root = document.documentElement;
  const positions = ['top', 'right', 'bottom', 'left'];
  const nativeInsets = window.safeAreaInsets;
  const hasNativeInsets = nativeInsets && positions.some((position) => Number.isFinite(nativeInsets[position]));

  if (hasNativeInsets) {
    positions.forEach((position) => {
      root.style.setProperty(`--safe-area-inset-${position}`, `${Math.max(nativeInsets[position] || 0, 0)}px`);
    });

    return;
  }

  if (!window.platform.isAndroid) {
    positions.forEach((position) => {
      root.style.setProperty(`--safe-area-inset-${position}`, `max(env(safe-area-inset-${position}), 0px)`);
    });
  }
}

if (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios') {
  document.body.classList.add('safe-area');

  applySafeArea();

  if (!window.platform.isAndroid || window.safeAreaInsets) {
    window.addEventListener('resize', applySafeArea);
    window.addEventListener('orientationchange', applySafeArea);
  }
}

if (window.platform.isMobile) {
  document.addEventListener('deviceready', () => {
    renderReactDom();
  }, false);

  // === Configure back button ===
  let totalBackButtonClicked = 1;
  let lastBackButtonClicked = new Date().valueOf();

  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (isScannerRunning) {
      stopScanner()
      return
    }

    if (canGoBack) {
      window.history.back(-1)
    } else {
      const currentMillis = new Date().valueOf();

      if ((currentMillis - lastBackButtonClicked) < 1000) {
        totalBackButtonClicked++;
      } else {
        totalBackButtonClicked = 1;
      }

      lastBackButtonClicked = currentMillis;

      switch (totalBackButtonClicked) {
        case 2:
          Toast.show({
            text: 'Press again to exit',
            duration: 'short',
            position: 'bottom'
          })
          break;
        case 3:
          CapacitorApp.exitApp();
          break;

        default: break;
      }
    }
  })
} else {
  renderReactDom();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
